/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BracketMatch } from './BracketMatch';
import {
    BracketMatchFromJSON,
    BracketMatchFromJSONTyped,
    BracketMatchToJSON,
    BracketMatchToJSONTyped,
} from './BracketMatch';

/**
 * 
 * @export
 * @interface BracketRound
 */
export interface BracketRound {
    /**
     * 
     * @type {number}
     * @memberof BracketRound
     */
    roundNumber?: number;
    /**
     * Round name such as Round 1, Quarterfinals, or Grand Final
     * @type {string}
     * @memberof BracketRound
     */
    name?: string;
    /**
     * 
     * @type {Array<BracketMatch>}
     * @memberof BracketRound
     */
    matches?: Array<BracketMatch>;
}

/**
 * Check if a given object implements the BracketRound interface.
 */
export function instanceOfBracketRound(value: object): value is BracketRound {
    return true;
}

export function BracketRoundFromJSON(json: any): BracketRound {
    return BracketRoundFromJSONTyped(json, false);
}

export function BracketRoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): BracketRound {
    if (json == null) {
        return json;
    }
    return {
        
        'roundNumber': json['roundNumber'] == null ? undefined : json['roundNumber'],
        'name': json['name'] == null ? undefined : json['name'],
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(BracketMatchFromJSON)),
    };
}

export function BracketRoundToJSON(json: any): BracketRound {
    return BracketRoundToJSONTyped(json, false);
}

export function BracketRoundToJSONTyped(value?: BracketRound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roundNumber': value['roundNumber'],
        'name': value['name'],
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(BracketMatchToJSON)),
    };
}

